const state = () => {
  return {
      order: {}      
    };
  };

export default state;
